"use strict";
exports.__esModule = true;
exports.glossaryActions = void 0;
var constants_1 = require("./constants");
// eslint-disable-next-line import/prefer-default-export
exports.glossaryActions = function (dispatch) { return ({
    setStatusBarData: function (statusBarData) {
        dispatch({ type: constants_1.REDUCER_ACTIONS.SET_STATUS_BAR_DATA, data: { statusBarData: statusBarData } });
    },
    setDownloadInitiated: function (downloadInitiated) {
        dispatch({ type: constants_1.REDUCER_ACTIONS.SET_DOWNLOAD_INITIATED, data: { downloadInitiated: downloadInitiated } });
    },
    setDisableUpload: function (disableUpload) {
        dispatch({ type: constants_1.REDUCER_ACTIONS.SET_DISABLE_UPLOAD, data: { disableUpload: disableUpload } });
    },
    setUploadStatus: function (uploadStatus) {
        dispatch({ type: constants_1.REDUCER_ACTIONS.SET_UPLOAD_STATUS, data: { uploadStatus: uploadStatus } });
    },
}); };
